/*
 * 表札の設置イメージ（THE DOOR PLATE・テスト実装）
 * - 入口は「カートに入れる」の下のボタンと、商品説明の中の写真バナー（snippets/doorplate-wall-entry-*）。
 *   シミュレーターはモーダル（<dialog>）で開く。S.source にどちらから開いたかを残す（計測を付けるときに使う）。
 * - 表札の絵は Cloudlift のプレビュー canvas（商品写真＋入力文字）から、バリアントごとの表札位置
 *   （doorplate-wall-quads.json、写真に対する 0〜1 の外接枠。ファサードシミュレーターPJ/tools/build_doorplate_wall_quads.py
 *   で作る）で切り出す。どのバリアントの絵か確かめられない canvas は使わず、バリアント写真（文字なし）で代用する。
 * - 外壁サンプル：表札の縮尺を固定し、外壁の写真を素材ごとの px/mm でそれに合わせて拡大縮小する。
 * - 自宅の写真：写真全体を表示し、表札とインターホン（参考、99×131mm）をひとまとまりで動かし、右下のつまみで拡大縮小する。
 *   写真にインターホンがあれば重ねて実寸に、無ければインターホンの見た目で大きさの見当をつける。
 *   位置と縮尺は写真の座標で持つので、画面の回転・大きさの変化でもずれない。
 * - 横の欄に今の表札（バリアント名と入力した文字）を出す。変えるときは商品ページに戻って選び直す。
 * - 注文フォーム・Cloudlift には何も書き込まない。写真は端末内でだけ使う。
 * - 計測（GA4・gtag 直送）: dwp_open / dwp_close（開いていた秒数・見た外壁の数・写真の有無・表札を動かしたか）/
 *   dwp_wall_select / dwp_mode_select / dwp_photo_upload。どれも product_handle 付き。カート投入は既存の add_to_cart と突き合わせる。
 */
(function () {
  // 外壁写真（1536×1024）の px/mm。各写真の規則的な模様（リブの間隔・板の高さ・タイルの段・
  // サイディングの溝 150mm）から測った値（白い2種は同じ写真を下絵に素材だけ替えたので同じ値）。元は ファサードシミュレーターPJ/assets/walls/（同じファイル）
  var WALLS = { white: 1.64, gray: 1.64, darkgray: 1.64, sidingdark: 1.605, galva: 1.84, wood: 1.80, tile: 1.97, whitetile: 1.97 };
  var IC = { w: 99, h: 131 };       // パナソニック V522/V523/V525/V570〜V574 の外寸
  var GAP = 50;                     // インターホン上端から表札下端まで（mm）

  // 計測：GA4 へ直接送る（JP の GA4 は Shopify の Google アプリの gtag が読み込む。GTM はアプリ GroPulse の別名
  // データレイヤーで動いているため window.dataLayer に積んでも届かない）。gtag が無いページでは何もしない。
  // 写真そのもの・入力した文字・個人を特定する情報は送らない。
  var GA4 = 'G-FWDGGHEVVL';
  var PRODUCT = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || null;
  function track(name, params) {
    var p = Object.assign({ send_to: GA4, product_handle: PRODUCT }, params || {});
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    if (window.DWP_DEBUG) console.log('[dwp]', name, p);
  }

  function loadImage(src) {
    return new Promise(function (ok, ng) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { ok(im); }; im.onerror = ng; im.src = src;
    });
  }

  function init(root) {
    // この表示と同じ商品のフォーム・Cloudlift を使う（ページ内の別の商品を拾わない）
    var scope = root.parentElement;
    while (scope && scope !== document.body && !scope.querySelector('form[action*="/cart/add"]')) scope = scope.parentElement;
    scope = scope || document;

    var stage = root.querySelector('[data-dwp-stage]');
    var ctx = stage.getContext('2d');
    var dialog = root.querySelector('[data-dwp-dialog]');
    var emptyEl = root.querySelector('[data-dwp-empty]');
    var hintEl = root.querySelector('[data-dwp-hint]');
    var toolsEl = root.querySelector('.dwp__tools');
    var S = {
      open: false, mode: 'wall', wall: 'white',
      quads: null, quadsState: 'idle',           // idle | loading | ok | error
      walls: {}, wallState: {},                  // 外壁ごとの idle | loading | ok | error
      home: null,
      showIc: true, icRect: null, plateRect: null,
      free: null,                                // 自宅の写真での表札 { x, y: 写真上の中心 px, k: 写真 px / mm }
      offset: { x: 0, y: 0 },                    // 外壁サンプルでの初期位置からのずれ（mm）
      variantImgs: {},                           // バリアントごとの { img, state }
      clVariant: null, initVariant: null, drag: null, view: null,
      titles: null, titlesState: 'idle',         // バリアント ID → バリアント名（/products/<handle>.js）
      source: null,                              // 開いた入口（cart | description）
      session: null                              // 今回開いている間の記録 { t0, walls: {}, photo, moved }
    };

    function form() { return scope.querySelector('form[action*="/cart/add"]'); }
    // 在庫なしのバリアントは <select name="id"> に値が入らない。そのときは選ばれているオプション（ラジオ）から引く
    var VARIANTS = [];
    try { VARIANTS = JSON.parse((root.querySelector('[data-dwp-variants]') || {}).textContent || '[]'); } catch (e) {}
    function currentVariantId() {
      var f = form(), el = f && f.querySelector('[name="id"]');
      if (el && el.value) return String(el.value);
      if (!f) return null;
      var picked = [], seen = {};
      f.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        if (/^properties\[/.test(r.name) || seen[r.name]) return;
        seen[r.name] = 1; picked.push(r.value);
      });
      for (var i = 0; i < VARIANTS.length; i++) {
        var o = VARIANTS[i][1];
        if (o.length === picked.length && o.every(function (x, k) { return x === picked[k]; })) return String(VARIANTS[i][0]);
      }
      return null;
    }
    // Cloudlift のプレビュー canvas（文字入り）。表示中でなくても中身は描かれている
    function cloudliftCanvas() { return scope.querySelector('canvas.cl-po--canvas.lower-canvas'); }

    // ---- 読み込み（失敗したものは、モーダルを開き直したときに読み直す） ----
    function loadQuads() {
      if (S.quadsState === 'ok' || S.quadsState === 'loading') return;
      S.quadsState = 'loading';
      fetch(root.dataset.quads).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (q) { S.quads = q; S.quadsState = 'ok'; draw(); })
        .catch(function () { S.quadsState = 'error'; draw(); });
    }
    function loadWall(k) {
      if (S.wallState[k] === 'ok' || S.wallState[k] === 'loading') return;
      S.wallState[k] = 'loading';
      loadImage(root.dataset['wall' + k.charAt(0).toUpperCase() + k.slice(1)])
        .then(function (im) { S.walls[k] = im; S.wallState[k] = 'ok'; draw(); })
        .catch(function () { S.wallState[k] = 'error'; draw(); });
    }
    function loadTitles() {
      if (S.titlesState === 'ok' || S.titlesState === 'loading') return;
      S.titlesState = 'loading';
      fetch(location.pathname.replace(/\/$/, '') + '.js').then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          S.titles = {};
          (p.variants || []).forEach(function (v) { S.titles[String(v.id)] = v.public_title || v.title; });
          S.titlesState = 'ok'; updatePlateInfo();
        })
        .catch(function () { S.titlesState = 'error'; });
    }
    function loadAll() {
      loadQuads();
      loadTitles();
      Object.keys(WALLS).forEach(loadWall);
      Object.keys(S.variantImgs).forEach(function (v) { if (S.variantImgs[v].state === 'error') delete S.variantImgs[v]; });
    }

    // ---- 表札の絵 ----
    // Cloudlift の canvas は、今のバリアントで描き直されたと確かめられたときだけ使う。
    // ページを開いたときのバリアントのままなら、最初の描画（このスクリプトより先に済むことがある）も今のバリアントの絵。
    // 数量など、バリアント以外の入力が変わっただけでは文字なしの写真に切り替えない
    function plateSource(q, vid) {
      var c = cloudliftCanvas();
      if (c && c.width > 0 && (S.clVariant === vid || (!S.clVariant && vid === S.initVariant))) return c;
      var e = S.variantImgs[vid];
      if (!e) {
        e = S.variantImgs[vid] = { img: null, state: 'loading' };
        loadImage(q.img + '?width=1600')
          .then(function (img) { e.img = img; e.state = 'ok'; draw(); })
          .catch(function () { e.state = 'error'; draw(); });
      }
      return e.img;
    }

    function shapePath(q, cx, cy, w, h) {
      ctx.beginPath();
      // c = 円・楕円、p = 両端が半円の長円（clé lapidary の楕円）、それ以外は長方形
      if (q.s === 'c') ctx.ellipse(cx, cy, w / 2, h / 2, 0, 0, Math.PI * 2);
      else if (q.s === 'p') { var r = Math.min(w, h) / 2; roundRect(cx - w / 2, cy - h / 2, w, h, r); }
      else ctx.rect(cx - w / 2, cy - h / 2, w, h);
    }
    function drawPlate(q, src, cx, cy, ppm) {
      var w = q.w * ppm, h = q.h * ppm;
      var sw = src.naturalWidth || src.width, sh = src.naturalHeight || src.height;
      // 枠（表札の外形）どおりに切り抜く。縁の面取り・光り方まで見せたいので内側には寄せない（位置データに i があればその割合だけ内側へ）
      var b = q.b, inset = q.i || 0;
      var bw = (b[2] - b[0]) * sw, bh = (b[3] - b[1]) * sh;
      var sx = b[0] * sw + bw * inset, sy = b[1] * sh + bh * inset;
      bw *= 1 - 2 * inset; bh *= 1 - 2 * inset;
      var t = Math.max(1, q.t);
      ctx.save();
      shapePath(q, cx, cy, w, h);
      ctx.shadowColor = 'rgba(0,0,0,0.32)';
      ctx.shadowBlur = (2 + t * 0.6) * ppm;
      ctx.shadowOffsetX = 0.4 * t * ppm;
      ctx.shadowOffsetY = (0.8 + 0.5 * t) * ppm;
      ctx.fillStyle = '#888'; ctx.fill();
      ctx.restore();
      ctx.save();
      shapePath(q, cx, cy, w, h); ctx.clip();
      ctx.drawImage(src, sx, sy, bw, bh, cx - w / 2, cy - h / 2, w, h);
      ctx.restore();
      S.plateRect = { x: cx - w / 2, y: cy - h / 2, w: w, h: h };
    }

    function roundRect(x, y, w, h, r) {
      ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
    }
    // インターホン（99×131mm）の参考表示。画像は使わず canvas の描画だけ（数十回の塗りで、ドラッグ中の毎フレームでも軽い）
    // ステンレスのヘアライン調の本体（左上の縁は明るく右下は暗く＝厚み）、黒ガラスのカメラ部、穴の並んだスピーカー、ベルの押しボタン
    function drawIntercom(cx, top, ppm) {
      var m = function (v) { return v * ppm; };
      var w = m(IC.w), h = m(IC.h), x = cx - w / 2, y = top, r = m(7), g, i, j;
      // 本体：壁に落ちる影 → 面（ヘアライン調の縦グラデーション）
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,0.28)'; ctx.shadowBlur = m(9); ctx.shadowOffsetX = m(1.2); ctx.shadowOffsetY = m(3.5);
      roundRect(x, y, w, h, r); ctx.fillStyle = '#b9bcc0'; ctx.fill();
      ctx.restore();
      g = ctx.createLinearGradient(x, y, x + w, y);
      g.addColorStop(0, '#c9ccd0'); g.addColorStop(0.18, '#dfe1e4'); g.addColorStop(0.45, '#cfd2d6');
      g.addColorStop(0.72, '#e2e4e7'); g.addColorStop(1, '#bfc2c6');
      roundRect(x, y, w, h, r); ctx.fillStyle = g; ctx.fill();
      ctx.save(); roundRect(x, y, w, h, r); ctx.clip();
      g = ctx.createLinearGradient(x, y, x, y + h);                         // 上から下へわずかに暗く
      g.addColorStop(0, 'rgba(255,255,255,0.18)'); g.addColorStop(1, 'rgba(0,0,0,0.10)');
      ctx.fillStyle = g; ctx.fillRect(x, y, w, h);
      ctx.globalAlpha = 0.07; ctx.fillStyle = '#fff';                       // ヘアラインの細い筋
      for (i = 0; i < 26; i++) ctx.fillRect(x + w * ((i * 37) % 100) / 100, y, Math.max(0.5, m(0.25)), h);
      ctx.restore();
      // 縁：左上に明るい線、右下に暗い線（面の厚み）
      ctx.save(); ctx.lineWidth = Math.max(1, m(0.6));
      roundRect(x + m(0.4), y + m(0.4), w - m(0.8), h - m(0.8), r); ctx.strokeStyle = 'rgba(255,255,255,0.75)'; ctx.stroke();
      roundRect(x, y, w, h, r); ctx.clip();
      roundRect(x - m(0.8), y - m(0.8), w + m(0.4), h + m(0.4), r); ctx.strokeStyle = 'rgba(70,74,80,0.45)'; ctx.lineWidth = Math.max(1, m(1.2)); ctx.stroke();
      ctx.restore();

      // カメラ部：黒ガラス（上半分に弱い映り込み）、レンズ、左右の赤外線ランプ
      var px = x + m(13), py = y + m(11), pw = w - m(26), ph = m(30);
      roundRect(px, py, pw, ph, m(7));
      g = ctx.createLinearGradient(px, py, px, py + ph); g.addColorStop(0, '#2c2f34'); g.addColorStop(1, '#141619');
      ctx.fillStyle = g; ctx.fill();
      ctx.save(); roundRect(px, py, pw, ph, m(7)); ctx.clip();
      g = ctx.createLinearGradient(px, py, px + pw * 0.6, py + ph);
      g.addColorStop(0, 'rgba(255,255,255,0.16)'); g.addColorStop(0.5, 'rgba(255,255,255,0.03)'); g.addColorStop(0.51, 'rgba(255,255,255,0)');
      ctx.fillStyle = g; ctx.fillRect(px, py, pw, ph);
      ctx.restore();
      var lx = cx, ly = py + ph / 2;
      ctx.beginPath(); ctx.arc(lx, ly, m(6), 0, Math.PI * 2); ctx.fillStyle = '#3a3e45'; ctx.fill();
      ctx.beginPath(); ctx.arc(lx, ly, m(4.4), 0, Math.PI * 2);
      g = ctx.createRadialGradient(lx - m(1.2), ly - m(1.2), m(0.4), lx, ly, m(4.4));
      g.addColorStop(0, '#2d3b52'); g.addColorStop(0.6, '#0b0d12'); g.addColorStop(1, '#050608');
      ctx.fillStyle = g; ctx.fill();
      ctx.beginPath(); ctx.arc(lx - m(1.5), ly - m(1.6), m(1), 0, Math.PI * 2); ctx.fillStyle = 'rgba(255,255,255,0.55)'; ctx.fill();
      ctx.fillStyle = '#4a2a2c';
      [-1, 1].forEach(function (s) { ctx.beginPath(); ctx.arc(lx + s * m(15), ly, m(1.6), 0, Math.PI * 2); ctx.fill(); });

      // スピーカー：小さな穴の並び（5段×9列、段ごとに半分ずらす）
      var sy = y + m(52), sx0 = cx - m(16);
      for (j = 0; j < 5; j++) for (i = 0; i < 9 - (j % 2); i++) {
        var hx = sx0 + m(4) * i + (j % 2 ? m(2) : 0), hy = sy + m(3.6) * j;
        ctx.beginPath(); ctx.arc(hx, hy, m(0.95), 0, Math.PI * 2); ctx.fillStyle = 'rgba(40,43,48,0.78)'; ctx.fill();
        ctx.beginPath(); ctx.arc(hx + m(0.25), hy + m(0.35), m(0.95), 0, Math.PI); ctx.strokeStyle = 'rgba(255,255,255,0.35)'; ctx.lineWidth = Math.max(0.5, m(0.3)); ctx.stroke();
      }

      // 呼び出しボタン：少し盛り上がった押しボタン（影＋上が明るいグラデーション）、ベルのマーク、上に表示灯
      var bx = x + m(17), by = y + h - m(46), bw = w - m(34), bh = m(30), br = m(6);
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,0.22)'; ctx.shadowBlur = m(2.5); ctx.shadowOffsetY = m(1);
      roundRect(bx, by, bw, bh, br); ctx.fillStyle = '#e9ebee'; ctx.fill();
      ctx.restore();
      g = ctx.createLinearGradient(bx, by, bx, by + bh); g.addColorStop(0, '#fbfcfd'); g.addColorStop(1, '#dfe2e6');
      roundRect(bx, by, bw, bh, br); ctx.fillStyle = g; ctx.fill();
      ctx.lineWidth = Math.max(1, m(0.5)); ctx.strokeStyle = 'rgba(0,0,0,0.14)'; ctx.stroke();
      var bcx = cx, bcy = by + bh / 2 + m(0.5), s = m(1);                  // ベル（約 9mm）
      ctx.beginPath();
      ctx.moveTo(bcx - 4.2 * s, bcy + 2.6 * s);
      ctx.bezierCurveTo(bcx - 3.4 * s, bcy + 1.4 * s, bcx - 3.4 * s, bcy - 0.4 * s, bcx - 3.2 * s, bcy - 1.6 * s);
      ctx.bezierCurveTo(bcx - 2.9 * s, bcy - 3.9 * s, bcx - 1.6 * s, bcy - 4.6 * s, bcx, bcy - 4.6 * s);
      ctx.bezierCurveTo(bcx + 1.6 * s, bcy - 4.6 * s, bcx + 2.9 * s, bcy - 3.9 * s, bcx + 3.2 * s, bcy - 1.6 * s);
      ctx.bezierCurveTo(bcx + 3.4 * s, bcy - 0.4 * s, bcx + 3.4 * s, bcy + 1.4 * s, bcx + 4.2 * s, bcy + 2.6 * s);
      ctx.closePath(); ctx.fillStyle = '#8b9097'; ctx.fill();
      ctx.beginPath(); ctx.arc(bcx, bcy + 3.6 * s, 1.1 * s, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx, by - m(5), m(1.3), 0, Math.PI * 2); ctx.fillStyle = '#8fc9b0'; ctx.fill();   // 表示灯
    }

    // 表札（上）とインターホン（下、GAP mm 離す）をひとまとまりで描く。cx, cy は表札の中心
    function drawSet(q, src, cx, cy, ppm, icAlpha) {
      if (S.showIc) {
        var top = cy + (q.h / 2 + GAP) * ppm;
        ctx.save(); ctx.globalAlpha = icAlpha; drawIntercom(cx, top, ppm); ctx.restore();
        S.icRect = { x: cx - IC.w * ppm / 2, y: top, w: IC.w * ppm, h: IC.h * ppm };
      }
      drawPlate(q, src, cx, cy, ppm);
    }

    // 外壁サンプルの縮尺は表札側で固定する（PC は横 620mm、スマホは縦 500mm が見える程度）。
    // 外壁の写真をこの縮尺に合わせて拡大縮小する＝どの外壁でも表札の見た目の大きさは変わらない
    function wallPpm(cw, ch) { return Math.max(cw / 620, ch / 500); }
    function drawWall(im, mmPerPx, ppm, cw, ch) {
      var k = ppm * mmPerPx, w = im.naturalWidth * k, h = im.naturalHeight * k;
      var x0 = (cw - w) / 2, y0 = (ch - h) / 2;
      while (x0 > 0) x0 -= w;                     // 足りない分は並べて埋める
      while (y0 > 0) y0 -= h;
      for (var y = y0; y < ch; y += h) for (var x = x0; x < cw; x += w) ctx.drawImage(im, x, y, w, h);
    }

    // 自宅の写真は全体を収めて表示（端のインターホンや設置場所が切れないように）。写真座標→画面座標の変換を返す
    function fitHome(im, cw, ch) {
      var s = Math.min(cw / im.naturalWidth, ch / im.naturalHeight);
      var v = { s: s, x: (cw - im.naturalWidth * s) / 2, y: (ch - im.naturalHeight * s) / 2 };
      ctx.fillStyle = '#d8d4cd'; ctx.fillRect(0, 0, cw, ch);
      ctx.drawImage(im, v.x, v.y, im.naturalWidth * s, im.naturalHeight * s);
      return v;
    }
    // 初めの大きさは写真を基準にする（130mm の表札が写真の短い辺の 22% 程度）。画面基準だと、縦長の画面に
    // 横長の写真を収めたときに写真に対して大きくなりすぎる
    function homeDefault() {
      var im = S.home;
      return { x: im.naturalWidth / 2, y: im.naturalHeight * 0.38, k: Math.min(im.naturalWidth, im.naturalHeight) * 0.22 / 130 };
    }

    function message(text, cw, ch) {
      ctx.fillStyle = '#e9e6e0'; ctx.fillRect(0, 0, cw, ch);
      ctx.fillStyle = '#666'; ctx.font = '13px sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText(text, cw / 2, ch / 2);
    }

    // ---- 描画 ----
    function draw() {
      if (!S.open) return;
      var dpr = window.devicePixelRatio || 1, cw = stage.clientWidth, ch = stage.clientHeight;
      if (!cw || !ch) return;
      var pw = Math.round(cw * dpr), ph = Math.round(ch * dpr);
      if (stage.width !== pw || stage.height !== ph) { stage.width = pw; stage.height = ph; }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, cw, ch);
      S.plateRect = null; S.icRect = null; S.view = null;
      var empty = S.mode === 'home' && !S.home;
      emptyEl.hidden = !empty; hintEl.hidden = empty; toolsEl.hidden = empty;
      if (empty) return;
      if (S.quadsState === 'error') return message('読み込みに失敗しました。閉じて開き直してください。', cw, ch);
      if (!S.quads) return message('読み込み中…', cw, ch);
      var vid = currentVariantId(), q = S.quads[vid];
      if (!q) return message('この組み合わせは設置イメージに対応していません', cw, ch);
      var ppm, cx, cy, bgOk = true;
      if (S.mode === 'wall') {
        ppm = wallPpm(cw, ch);
        var wall = S.walls[S.wall];
        if (wall) drawWall(wall, 1 / WALLS[S.wall], ppm, cw, ch);
        else {
          bgOk = false;
          message(S.wallState[S.wall] === 'error' ? '外壁の画像を読み込めませんでした。閉じて開き直してください。' : '読み込み中…', cw, ch);
        }
        var setH = q.h + (S.showIc ? GAP + IC.h : 0);   // 表札＋インターホンを縦の中央に
        cx = cw / 2 + S.offset.x * ppm;
        cy = (ch - setH * ppm) / 2 + q.h * ppm / 2 + S.offset.y * ppm;
      } else {
        var v = S.view = fitHome(S.home, cw, ch);
        if (!S.free) S.free = homeDefault();
        ppm = S.free.k * v.s; cx = v.x + S.free.x * v.s; cy = v.y + S.free.y * v.s;
      }
      var src = plateSource(q, vid);
      if (!src) {
        if (bgOk) {
          var st = S.variantImgs[vid] && S.variantImgs[vid].state;
          ctx.fillStyle = 'rgba(0,0,0,0.55)'; ctx.font = '13px sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText(st === 'error' ? '表札の画像を読み込めませんでした。閉じて開き直してください。' : '表札を読み込み中…', cw / 2, ch / 2);
        }
        return;
      }
      drawSet(q, src, cx, cy, ppm, S.mode === 'home' ? 0.8 : 1);
      if (S.mode === 'home') { var h = handlePos(); drawHandle(h.x, h.y); }
    }

    // 大きさを変えるつまみ：まとまり（表札＋表示中ならインターホン）の右下
    function handlePos() {
      var r = S.icRect || S.plateRect, pr = S.plateRect;
      return { x: Math.max(pr.x + pr.w, r.x + r.w), y: r.y + r.h };
    }
    function drawHandle(x, y) {
      ctx.save(); ctx.fillStyle = '#fff'; ctx.strokeStyle = 'rgba(0,0,0,0.5)'; ctx.lineWidth = 1;
      ctx.shadowColor = 'rgba(0,0,0,0.5)'; ctx.shadowBlur = 3;
      ctx.fillRect(x - 7, y - 7, 14, 14); ctx.strokeRect(x - 7, y - 7, 14, 14);
      ctx.restore();
    }

    // ---- 操作 ----
    // 外壁サンプル：表札とインターホンをまとめて移動（縮尺は固定）
    // 自宅の写真：まとめて移動＋右下のつまみで拡大縮小（写真のインターホンに重ねれば実寸）
    // どちらも表札の中心は画面の中に留める（画面の外に出してつかめなくなるのを防ぐ）
    function clampCenter(cx, cy) {
      var cw = stage.clientWidth, ch = stage.clientHeight;
      return { x: Math.min(Math.max(cx, 0), cw), y: Math.min(Math.max(cy, 0), ch) };
    }
    function moveBy(dx, dy, base) {                // dx, dy: 画面 px。base: ドラッグ開始時の位置
      if (S.mode === 'home') {
        var v = S.view; if (!v) return;
        var c = clampCenter(v.x + base.x * v.s + dx, v.y + base.y * v.s + dy);
        S.free.x = (c.x - v.x) / v.s; S.free.y = (c.y - v.y) / v.s;
      } else {
        var k = wallPpm(stage.clientWidth, stage.clientHeight), r = S.plateRect;
        var c0 = { x: r.x + r.w / 2 - S.offset.x * k, y: r.y + r.h / 2 - S.offset.y * k };   // ずれ 0 のときの中心
        var c2 = clampCenter(c0.x + (base.x * k) + dx, c0.y + (base.y * k) + dy);
        S.offset = { x: (c2.x - c0.x) / k, y: (c2.y - c0.y) / k };
      }
      if (S.session && (dx || dy)) S.session.moved = true;
      draw();
    }
    function scaleBy(f) { if (S.mode === 'home' && S.free) { S.free.k = Math.max(0.05, S.free.k * f); if (S.session) S.session.moved = true; draw(); } }
    function resetPlacement() { S.offset = { x: 0, y: 0 }; S.free = null; draw(); }

    function pos(e) { var b = stage.getBoundingClientRect(); return { x: e.clientX - b.left, y: e.clientY - b.top }; }
    function inRect(p, r) { return r && p.x >= r.x && p.x <= r.x + r.w && p.y >= r.y && p.y <= r.y + r.h; }
    stage.addEventListener('pointerdown', function (e) {
      var p = pos(e);
      if (!S.plateRect) return;
      if (S.mode === 'home') {
        var h = handlePos(), v = S.view, c = { x: v.x + S.free.x * v.s, y: v.y + S.free.y * v.s };
        if (Math.abs(p.x - h.x) < 18 && Math.abs(p.y - h.y) < 18) {
          S.drag = { kind: 'size', k: S.free.k, c: c, d0: Math.max(20, Math.hypot(p.x - c.x, p.y - c.y)) };
        } else if (inRect(p, S.plateRect) || inRect(p, S.icRect)) {
          S.drag = { kind: 'move', p: p, o: { x: S.free.x, y: S.free.y } };
        } else return;
      } else if (inRect(p, S.plateRect) || inRect(p, S.icRect)) {
        S.drag = { kind: 'move', p: p, o: { x: S.offset.x, y: S.offset.y } };
      } else return;
      stage.setPointerCapture(e.pointerId); e.preventDefault();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!S.drag) return;
      var p = pos(e), d = S.drag;
      if (d.kind === 'size') { S.free.k = Math.max(0.05, d.k * Math.hypot(p.x - d.c.x, p.y - d.c.y) / d.d0); if (S.session) S.session.moved = true; draw(); }
      else moveBy(p.x - d.p.x, p.y - d.p.y, d.o);
    });
    stage.addEventListener('pointerup', function () { S.drag = null; });
    stage.addEventListener('pointercancel', function () { S.drag = null; });
    // キーボード：矢印で移動（Shift で大きく）、自宅の写真では ＋／− で拡大縮小、0 で配置を戻す
    stage.addEventListener('keydown', function (e) {
      if (!S.plateRect) return;
      var step = e.shiftKey ? 20 : 2, m = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] }[e.key];
      if (m) moveBy(m[0], m[1], S.mode === 'home' ? { x: S.free.x, y: S.free.y } : { x: S.offset.x, y: S.offset.y });
      else if (e.key === '+' || e.key === '=') scaleBy(1.03);
      else if (e.key === '-') scaleBy(1 / 1.03);
      else if (e.key === '0') resetPlacement();
      else return;
      e.preventDefault();
    });

    // ---- モーダルの開閉。商品画像・Cloudlift のギャラリーには触らない（プレビュー canvas は裏で描かれ続ける） ----
    function onClosed() {
      if (S.session) {
        var ss = S.session; S.session = null;
        track('dwp_close', { entry: S.source || 'unknown', variant_id: currentVariantId(),
          seconds: Math.round((Date.now() - ss.t0) / 1000), walls_viewed: Object.keys(ss.walls).length,
          used_photo: ss.photo, moved_plate: ss.moved, last_mode: S.mode });
      }
      S.open = false; S.drag = null;
      document.documentElement.classList.remove('dwp-lock');
    }
    function openDialog() {
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.classList.add('dwp-lock');
      S.open = true;
      S.session = { t0: Date.now(), walls: {}, photo: false, moved: false };
      noteView();                                  // 開いたときに見えている外壁・写真も「見た」に数える
      track('dwp_open', { entry: S.source || 'unknown', variant_id: currentVariantId(), mode: S.mode, wall: S.mode === 'wall' ? S.wall : null });
      loadAll();
      updatePlateInfo();
      requestAnimationFrame(draw);
    }
    function closeDialog() {
      if (typeof dialog.close === 'function') { if (dialog.open) dialog.close(); }   // close イベントで onClosed
      else { dialog.removeAttribute('open'); onClosed(); }
    }
    dialog.addEventListener('close', onClosed);
    // 枠の外（背景の暗い部分）を押したら閉じる
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closeDialog(); });

    // 横の欄の「表示中の表札」。文字はテキスト入力のときだけ（データ入稿では出さない）
    function updatePlateInfo() {
      var vid = currentVariantId(), f = form();
      var title = (S.titles && S.titles[vid]) || '';
      var ta = f && f.querySelector('[name="properties[メインテキスト]"]');
      var text = ta ? ta.value.replace(/\s+/g, ' ').trim() : '';
      root.querySelector('[data-dwp-plate]').textContent = title.replace(/\s*\/\s*/g, '・') || 'THE DOOR PLATE';
      var t = root.querySelector('[data-dwp-plate-text]');
      t.textContent = text ? '「' + text + '」' : ''; t.hidden = !text;
    }

    // 計測用：いま表示している外壁・自宅の写真を、今回開いている間の記録に足す
    function noteView() {
      if (!S.session) return;
      if (S.mode === 'wall') S.session.walls[S.wall] = 1;
      else if (S.mode === 'home' && S.home) S.session.photo = true;
    }
    function setMode(mode) {
      if (S.open && mode !== S.mode) track('dwp_mode_select', { mode: mode });
      S.mode = mode; S.offset = { x: 0, y: 0 };
      noteView();
      hintEl.textContent = mode === 'home' ? 'ドラッグで移動、右下の四角で大きさを変えられます' : '表札をドラッグして動かせます';
      root.querySelectorAll('[data-dwp-mode]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.dwpMode === mode)); });
      root.querySelector('[data-dwp-walls]').hidden = mode !== 'wall';
      root.querySelector('[data-dwp-home]').hidden = mode !== 'home';
      draw();
    }
    S.initVariant = currentVariantId();
    // 入口（カートの下のボタン・説明の中のバナー）はモーダルの外にある。同じ商品の範囲から拾って表示する。
    // 説明を全幅で出す設定ではバナーがフォームの外に出るので、ページに設置イメージが1つだけならページ全体から拾う
    var openScope = document.querySelectorAll('[data-dwp]').length > 1 ? scope : document;
    openScope.querySelectorAll('[data-dwp-open]').forEach(function (b) {
      b.hidden = false;
      b.addEventListener('click', function () { S.source = b.dataset.dwpSource || null; openDialog(); });
    });
    root.querySelectorAll('[data-dwp-close]').forEach(function (b) { b.addEventListener('click', closeDialog); });
    // スマホのシートの開閉：つまみのタップか、シート上の縦スワイプ（下で閉じる・上で開く）。横スクロール（外壁の一覧）は邪魔しない
    var side = root.querySelector('[data-dwp-side]'), grip = root.querySelector('[data-dwp-grip]');
    function setFolded(on) {
      side.classList.toggle('is-folded', on);
      grip.setAttribute('aria-expanded', String(!on));
      grip.setAttribute('aria-label', on ? '背景の選択を開く' : '背景の選択を閉じる');
    }
    grip.addEventListener('click', function () { setFolded(!side.classList.contains('is-folded')); });
    // 指に追従：縦に 8px 動いたらドラッグ開始。折りたたむ部分の高さを指の位置に合わせ、離したら開く／閉じるに収める
    // （半分より閉じていれば閉じる。素早く払ったときは位置に関係なくその向き）
    var fold = root.querySelector('[data-dwp-fold]'), swipe = null, skipClickUntil = 0;
    function clearInline() { fold.style.transition = fold.style.maxHeight = fold.style.opacity = fold.style.marginTop = ''; }
    side.addEventListener('pointerdown', function (e) {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var folded = side.classList.contains('is-folded');
      clearInline();
      swipe = { x: e.clientX, y: e.clientY, id: e.pointerId, folded: folded, full: fold.scrollHeight, h0: folded ? 0 : fold.scrollHeight,
                drag: false, t: e.timeStamp, ly: e.clientY, v: 0 };
    });
    side.addEventListener('pointermove', function (e) {
      if (!swipe || e.pointerId !== swipe.id) return;
      var dx = e.clientX - swipe.x, dy = e.clientY - swipe.y;
      if (!swipe.drag) {
        if (Math.abs(dy) < 8 || Math.abs(dy) < Math.abs(dx) * 1.5) return;
        swipe.drag = true;
        if (swipe.folded) { side.classList.remove('is-folded'); swipe.full = fold.scrollHeight; }
        try { side.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var dt = Math.max(1, e.timeStamp - swipe.t);
      swipe.v = (e.clientY - swipe.ly) / dt; swipe.ly = e.clientY; swipe.t = e.timeStamp;   // px/ms、下向きが正
      var h = Math.min(swipe.full, Math.max(0, swipe.h0 - dy)), k = h / swipe.full;
      fold.style.transition = 'none'; fold.style.maxHeight = h + 'px'; fold.style.opacity = String(k); fold.style.marginTop = (-12 * (1 - k)) + 'px';
      e.preventDefault();
    });
    function endSwipe(e) {
      if (!swipe || e.pointerId !== swipe.id) return;
      var sw = swipe; swipe = null;
      if (!sw.drag) return;
      skipClickUntil = Date.now() + 400;          // 指を離した直後にブラウザが出すタップ（つまみの開閉など）を無視する
      var h = parseFloat(fold.style.maxHeight) || 0;
      var fold_ = Math.abs(sw.v) > 0.5 ? sw.v > 0 : h < sw.full / 2;
      fold.style.transition = '';
      requestAnimationFrame(function () {
        fold.style.maxHeight = (fold_ ? 0 : sw.full) + 'px'; fold.style.opacity = fold_ ? '0' : '1'; fold.style.marginTop = fold_ ? '-12px' : '0px';
        setTimeout(function () { setFolded(fold_); clearInline(); }, 300);
      });
    }
    side.addEventListener('pointerup', endSwipe);
    side.addEventListener('pointercancel', endSwipe);
    // ドラッグを離したところにあるボタン（外壁など）を押したことにしない
    side.addEventListener('click', function (e) { if (Date.now() < skipClickUntil) { e.stopPropagation(); e.preventDefault(); } }, true);
    root.querySelectorAll('[data-dwp-mode]').forEach(function (b) { b.addEventListener('click', function () { setMode(b.dataset.dwpMode); }); });
    root.querySelector('[data-dwp-reset]').addEventListener('click', resetPlacement);
    root.querySelector('[data-dwp-show-ic]').addEventListener('click', function () {
      S.showIc = !S.showIc;
      this.setAttribute('aria-pressed', String(S.showIc));
      draw();
    });
    root.querySelectorAll('[data-dwp-wall]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.wall = b.dataset.dwpWall;
        noteView();
        track('dwp_wall_select', { wall: S.wall });
        root.querySelectorAll('[data-dwp-wall]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        draw();
      });
    });
    // 写真を選ぶ欄は、画像の上（未選択のとき）と横の欄の2か所
    root.querySelectorAll('[data-dwp-file]').forEach(function (input) {
      input.addEventListener('change', function (e) {
        var f = e.target.files && e.target.files[0]; if (!f) return;
        var url = URL.createObjectURL(f), im = new Image();
        im.onload = function () {
          URL.revokeObjectURL(url);                // デコード済みの画像は Image 側に残る
          S.home = im; S.free = null; root.querySelector('[data-dwp-file-label]').textContent = '別の写真に変える';
          root.querySelector('[data-dwp-home]').classList.add('is-picked'); draw();
          if (S.session) S.session.photo = true;
          track('dwp_photo_upload', {});
        };
        // 読み込めない写真（HEIC など）は、選んだのに何も起きないように見えないよう、選ぶ欄の文言で伝える
        im.onerror = function () {
          URL.revokeObjectURL(url);
          var msg = 'この写真は読み込めませんでした。別の写真を選んでください';
          root.querySelector('[data-dwp-file-label]').textContent = msg;
          root.querySelector('.dwp__empty-text').textContent = msg;
        };
        im.src = url;
        e.target.value = '';                       // 同じ写真を選び直しても change が来るように
      });
    });

    // Cloudlift が描き直したら、その時点のバリアントの絵として使う
    document.addEventListener('preview:rendered', function () { S.clVariant = currentVariantId(); draw(); if (S.open) updatePlateInfo(); }, true);
    document.addEventListener('change', function (e) {
      var f = form();
      if (f && f.contains(e.target)) { S.offset = { x: 0, y: 0 }; setTimeout(function () { draw(); updatePlateInfo(); }, 0); }
    }, true);
    document.addEventListener('variant:change', function () { setTimeout(draw, 0); });
    if (window.ResizeObserver) new ResizeObserver(function () { draw(); }).observe(stage);
    window.addEventListener('resize', draw);
  }

  document.querySelectorAll('[data-dwp]').forEach(init);
})();
